<template>
  <v-col cols="12">
    <v-card class="mt-6" flat min-width="300px">
      <v-card v-if="isCartoMap" flat width="98%" class="mb-6">
        <map-view :list="locationList"></map-view>
      </v-card>
      <v-card-title class="headline display-1">
        {{ $t("tableTitle.list_equipment") }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('tableStatus.searchAll')"
          single-line
          hide-details
          class="mt-n2"
        >
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="list"
          item-key="name"
          class="table is_bordered"
          :loading="loading"
          :search="search"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @click:row="clicked"
        >
          <template v-slot:item="{ item }">
            <c-row
              :item="item"
              @click="clicked(item)"
              :headers="headers"
              rtl
              ignore-null-val
            ></c-row>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { UserSessionData } from "../../mixins/userData";
import MapView from "../../components/Map";
import moment from "../../plugins/moment";
import USER_API from "../../api/user";
import { mapGetters } from "vuex";

export default {
  name: "PluginGenericobjectEqpt",
  components: { MapView },
  data() {
    return {
      page: 1,
      itemsPerPage: 30,
      search: "",
      isCartoMap: true,
      locationList: [],
      loading: false,
      headers: [
        {
          text: this.$t("header.name"),
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: this.$t("header.shape"),
          align: "left",
          sortable: false,
          value: "operationnel"
        },
        {
          text: this.$t("header.comment"),
          align: "left",
          sortable: false,
          value: "comment"
        },
        {
          text: this.$t("header.measurement"),
          align: "left",
          sortable: false,
          value: "dimension_alim"
        },
        {
          text: this.$t("header.year_installation"),
          align: "right",
          sortable: false,
          value: "creationdate"
        },
        {
          text: this.$t("header.residual_life"),
          align: "right",
          sortable: false,
          value: "duree"
        }
      ]
    };
  },
  mixins: [UserSessionData],
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters([
      "getUserProfile",
      "getUserProfiles",
      "getEntity",
      "isAuth",
      "getActiveEntity",
      "getUserToken",
    ])
  },
  methods: {
    clicked: function(item) {
      let clientName = this.getActiveEntity.completename.split(">")[1].trim();
      window.open(
        "https://portail.pilote.immo/clients/" +
          clientName +
          "/itemtype.php?user=" +
          this.getUserToken +
          "&ept=" +
          item.code_pi +
          "&entity=" +
          this.$route.params.id
      );
    },
    loadData() {
      if (this.display && this.isAuth) {
        this.loading = true;
        USER_API.getEquipment("Eqpt")
          .then(response => {
            this.list = response.data;
            const size = this.list.length;
            this.locationList = [];
            let nbgps = 0;
            let clientName = this.getActiveEntity.completename
              .split(">")[1]
              .trim();
            if (size > 0) {
              //pour mettre les points sur la carte
              for (let i = 0; i < size; i++) {
                if (this.list[i].gps_alim && this.list[i].gps_alim !== "/") {
                  nbgps = nbgps + 1;
                  this.locationList.push({
                    name:
                      isNaN(this.list[i].name) === true
                        ? this.list[i].name.toUpperCase()
                        : this.list[i].name,
                    operationnel: this.list[i].operationnel,
                    /* si souci avec les markers, il faudrait peut etre utiliser cela
                    operationnel:
                      this.list[i].operationnel !== undefined
                        ? this.list[i].operationnel
                        : "NA",*/
                    lat: this.list[i].gps_alim.split("/")[0],
                    lng: this.list[i].gps_alim.split("/")[1],
                    link:
                      "https://portail.pilote.immo/clients/" +
                      clientName +
                      "/itemtype.php?user=" +
                      this.getUserToken +
                      "&ept=" +
                      this.list[i].code_pi +
                      "&entity=" +
                      this.$route.params.id
                  });
                }
              }
              //pour écrire le tableau
              for (let i = 0; i < size; i++) {
                if (this.list[i].operationnel === 1) {
                  this.list[i].operationnel = "OK";
                } else {
                  this.list[i].operationnel = "NOK";
                }
                if (isNaN(this.list[i].name) === true) {
                  this.list[i].name = this.list[i].name.toUpperCase();
                }
                this.list[i].dimension_alim = this.list[i].dimension_alim;
                if (this.list[i].expirationdate != null) {
                  this.list[i].duree =
                    this.list[i].expirationdate.split("-")[0] -
                    moment().format("YYYY") +
                    " an(s)";
                }
              }
            }
            if (nbgps === 0) {
              this.isCartoMap = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  watch: {
    display() {
      this.loadData();
    }
  }
};
</script>
